function init() {
  if('IntersectionObserver' in window) {
    var fades = document.querySelectorAll('.fade-in-up');
    var fadesObserver = new IntersectionObserver(function(entries, observer) {
      [].forEach.call(entries, function(entry) {
        // console.log(entry.intersectionRatio);
        // if(entry.intersectionRatio > 0.5) {
        if(entry.isIntersecting) {
          entry.target.classList.add('animated');
          observer.unobserve(entry.target);
        }
      });
    }, {
      root: null, // Defaults to the browser viewport
      rootMargin: '0px',
      threshold: 0.15,
    });

    [].forEach.call(fades, function(fade) {
      fadesObserver.observe(fade);
    });
  }
}

export default init;



// WEBPACK FOOTER //
// ./scripts/flexible-content/animations.js